export class ConversionUtilities {
  /**
   * For .net properties datatyped as TimeSpan, the return would be 00:00:00 (Hours - Minutes - Seconds)
   * @param timeSpan 00:00:00
   * @return date Hours and Minutes
   */
  static createDateFromTimeSpan(timeSpan: string) {
    const arr = timeSpan.split(':');
    let hour = arr[0];
    if (hour.charAt(0) === '0') {
      hour = hour.substr(1, 1);
    }
    const minute = parseInt(arr[1]);
    const date = new Date();
    date.setHours(parseInt(hour), minute);

    return date;
  }

  static getHoursMinutesSeconds(start: Date, end: Date) {
    const a = new Date(start);
    const b = new Date(end);
    const duration = b.getTime() - a.getTime();

    let milliseconds: any = Math.floor((duration % 1000) / 100),
      seconds: any = Math.floor((duration / 1000) % 60),
      minutes: any = Math.floor((duration / (1000 * 60)) % 60),
      hours: any = Math.floor((duration / (1000 * 60 * 60)) % 24);

    hours = (hours < 10) ? '0' + hours : hours;
    minutes = (minutes < 10) ? '0' + minutes : minutes;
    seconds = (seconds < 10) ? '0' + seconds : seconds;

    return hours + ':' + minutes + ':' + seconds;
  }

  static getInitialDate(initialDate: Date): Date {
    return new Date(initialDate.getFullYear(), initialDate.getMonth() ,
      initialDate.getDate(), 0, 0, 0, 1);
  }

  static getEndDate(EndDate: Date): Date {
    return new Date(EndDate.getFullYear(), EndDate.getMonth() ,
      EndDate.getDate(), 23, 59, 59, 999);
  }

  static convertUTCDateToLocalDateFromString(dateString) {
    if (!dateString) {
      return null;
    }

    const date = new Date(dateString);
    return this.convertUTCDateToLocalDate(date);
  }

  static convertUTCDateToLocalDate(date) {
    return new Date(
      Date.UTC(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
      )
    );
  }

  public static getAdjustedTimezoneDate(utc: Date, tzID: string): Date {

    // find timezone offset minutes
    const offset = this.getTimezoneOffsetMinutes(tzID);

    // add offset, *may be negative
    utc = new Date(utc);
    utc.setMinutes(utc.getMinutes() + offset);

    return utc;
  }

  static getTimezoneOffsetMinutes(tzID: string): number {
    let offset = 0;
    switch (tzID.toUpperCase()) {
      case 'F2000000-2000-0000-0000-000000000000':
        offset = -720;
        break;
      case 'F2000000-2000-0000-0000-000000000001':
        offset = -660;
        break;
      case 'F2000000-2000-0000-0000-000000000002':
        offset = -600;
        break;
      case 'F2000000-2000-0000-0000-000000000003':
        offset = -540;
        break;
      case 'F2000000-2000-0000-0000-000000000004':
        offset = -480;
        break;
      case 'F2000000-2000-0000-0000-000000000010':
        offset = -420;
        break;
      case 'F2000000-2000-0000-0000-000000000013':
        offset = -420;
        break;
      case 'F2000000-2000-0000-0000-000000000015':
        offset = -420;
        break;
      case 'F2000000-2000-0000-0000-000000000020':
        offset = -360;
        break;
      case 'F2000000-2000-0000-0000-000000000025':
        offset = -360;
        break;
      case 'F2000000-2000-0000-0000-000000000030':
        offset = -360;
        break;
      case 'F2000000-2000-0000-0000-000000000033':
        offset = -360;
        break;
      case 'F2000000-2000-0000-0000-000000000035':
        offset = -300;
        break;
      case 'F2000000-2000-0000-0000-000000000040':
        offset = -300;
        break;
      case 'F2000000-2000-0000-0000-000000000045':
        offset = -300;
        break;
      case 'F2000000-2000-0000-0000-000000000050':
        offset = -240;
        break;
      case 'F2000000-2000-0000-0000-000000000055':
        offset = -240;
        break;
      case 'F2000000-2000-0000-0000-000000000056':
        offset = -240;
        break;
      case 'F2000000-2000-0000-0000-000000000060':
        offset = -150;
        break;
      case 'F2000000-2000-0000-0000-000000000065':
        offset = -180;
        break;
      case 'F2000000-2000-0000-0000-000000000070':
        offset = -180;
        break;
      case 'F2000000-2000-0000-0000-000000000073':
        offset = -180;
        break;
      case 'F2000000-2000-0000-0000-000000000075':
        offset = -120;
        break;
      case 'F2000000-2000-0000-0000-000000000080':
        offset = -60;
        break;
      case 'F2000000-2000-0000-0000-000000000083':
        offset = -60;
        break;
      case 'F2000000-2000-0000-0000-000000000085':
        offset = 0;
        break;
      case 'F2000000-2000-0000-0000-000000000090':
        offset = 0;
        break;
      case 'F2000000-2000-0000-0000-000000000095':
        offset = 60;
        break;
      case 'F2000000-2000-0000-0000-000000000100':
        offset = 60;
        break;
      case 'F2000000-2000-0000-0000-000000000105':
        offset = 60;
        break;
      case 'F2000000-2000-0000-0000-000000000110':
        offset = 60;
        break;
      case 'F2000000-2000-0000-0000-000000000113':
        offset = 60;
        break;
      case 'F2000000-2000-0000-0000-000000000115':
        offset = 120;
        break;
      case 'F2000000-2000-0000-0000-000000000120':
        offset = 120;
        break;
      case 'F2000000-2000-0000-0000-000000000125':
        offset = 120;
        break;
      case 'F2000000-2000-0000-0000-000000000130':
        offset = 120;
        break;
      case 'F2000000-2000-0000-0000-000000000135':
        offset = 120;
        break;
      case 'F2000000-2000-0000-0000-000000000140':
        offset = 120;
        break;
      case 'F2000000-2000-0000-0000-000000000145':
        offset = 180;
        break;
      case 'F2000000-2000-0000-0000-000000000150':
        offset = 180;
        break;
      case 'F2000000-2000-0000-0000-000000000155':
        offset = 180;
        break;
      case 'F2000000-2000-0000-0000-000000000158':
        offset = 180;
        break;
      case 'F2000000-2000-0000-0000-000000000160':
        offset = 210;
        break;
      case 'F2000000-2000-0000-0000-000000000165':
        offset = 240;
        break;
      case 'F2000000-2000-0000-0000-000000000170':
        offset = 240;
        break;
      case 'F2000000-2000-0000-0000-000000000175':
        offset = 270;
        break;
      case 'F2000000-2000-0000-0000-000000000180':
        offset = 300;
        break;
      case 'F2000000-2000-0000-0000-000000000185':
        offset = 300;
        break;
      case 'F2000000-2000-0000-0000-000000000190':
        offset = 330;
        break;
      case 'F2000000-2000-0000-0000-000000000193':
        offset = 345;
        break;
      case 'F2000000-2000-0000-0000-000000000195':
        offset = 360;
        break;
      case 'F2000000-2000-0000-0000-000000000200':
        offset = 360;
        break;
      case 'F2000000-2000-0000-0000-000000000201':
        offset = 360;
        break;
      case 'F2000000-2000-0000-0000-000000000203':
        offset = 390;
        break;
      case 'F2000000-2000-0000-0000-000000000205':
        offset = 420;
        break;
      case 'F2000000-2000-0000-0000-000000000207':
        offset = 420;
        break;
      case 'F2000000-2000-0000-0000-000000000210':
        offset = 480;
        break;
      case 'F2000000-2000-0000-0000-000000000215':
        offset = 480;
        break;
      case 'F2000000-2000-0000-0000-000000000220':
        offset = 480;
        break;
      case 'F2000000-2000-0000-0000-000000000225':
        offset = 480;
        break;
      case 'F2000000-2000-0000-0000-000000000227':
        offset = 480;
        break;
      case 'F2000000-2000-0000-0000-000000000230':
        offset = 540;
        break;
      case 'F2000000-2000-0000-0000-000000000235':
        offset = 540;
        break;
      case 'F2000000-2000-0000-0000-000000000240':
        offset = 540;
        break;
      case 'F2000000-2000-0000-0000-000000000245':
        offset = 570;
        break;
      case 'F2000000-2000-0000-0000-000000000250':
        offset = 570;
        break;
      case 'F2000000-2000-0000-0000-000000000255':
        offset = 600;
        break;
      case 'F2000000-2000-0000-0000-000000000260':
        offset = 600;
        break;
      case 'F2000000-2000-0000-0000-000000000265':
        offset = 600;
        break;
      case 'F2000000-2000-0000-0000-000000000270':
        offset = 600;
        break;
      case 'F2000000-2000-0000-0000-000000000275':
        offset = 600;
        break;
      case 'F2000000-2000-0000-0000-000000000280':
        offset = 660;
        break;
      case 'F2000000-2000-0000-0000-000000000285':
        offset = 720;
        break;
      case 'F2000000-2000-0000-0000-000000000290':
        offset = 720;
        break;
      case 'F2000000-2000-0000-0000-000000000300':
        offset = 780;
        break;
    }

    return offset;
  }

  static roundDecimal(num: number, decimalPlaces: number = 2) {
    const p = Math.pow(10, decimalPlaces);
    return Math.round(num * p) / p;
  }

}
